import { captureException as sentryCaptureException } from '@sentry/react';
import { colors } from '@modernhealth/vital-foundation';

import { CircleTopicFormat } from 'src/generated/graphql';
import { ReactComponent as MountainImage } from 'src/assets/images/Mountains.svg';
import { ReactComponent as BlueMountainImage } from 'src/assets/images/BlueMountains.svg';
import { ReactComponent as BricksImage } from 'src/assets/images/Bricks.svg';
import { ReactComponent as TreesImage } from 'src/assets/images/Trees.svg';
import { captureException } from 'src/shared/utils/captureException';

export function formatCircleBackgroundStyle(circleFormat: CircleTopicFormat | string): {
  Image: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  borderColor: string;
  textColor: string;
} {
  switch (circleFormat) {
    case CircleTopicFormat.Discussion:
      return { Image: BlueMountainImage, borderColor: '#E8F6FC', textColor: colors.blue55 };
    case CircleTopicFormat.Fireside:
      return { Image: TreesImage, borderColor: colors.violet05, textColor: colors.violet55 };
    case CircleTopicFormat.ListenAndLearn:
      return { Image: MountainImage, borderColor: colors.cyan05, textColor: colors.cyan55 };
    case CircleTopicFormat.Workshop:
      return { Image: BricksImage, borderColor: colors.orange05, textColor: colors.orange55 };
    default:
      sentryCaptureException(new Error(`Unhandled Circle format ${circleFormat}`));
      captureException(new Error(`Unhandled Circle format ${circleFormat}`));
      return { Image: BlueMountainImage, borderColor: colors.blue55, textColor: colors.blue55 };
  }
}
